// extracted by mini-css-extract-plugin
export default {"notificationItem":"style_notificationItem__czxkA"};